'use strict';
var app = require('angular').module('dashboard');

app.controller('dashboardGraphsCtrl', ['$state', 'departments', 'Department', 'Integration', 'dialog', 'graphs', '$translate', 'Authentication', '$uibModal', 'toast', '$rootScope', '$scope', require('./dashboardGraphsCtrl')]);
app.directive('graphUnit', [require('./dashboardGraphsDirective')]);
app.config(['$stateProvider', require('./dashboardGraphsConfig')]);
